/* assets/cod-cart-drawer.js (UPDATE: shipping rules aligned with PHP + better images + safer cart intercept) */

(function () {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  const CART_URL = root + 'cart.js';
  const CHANGE_URL = root + 'cart/change.js';
  const VARIANT_URL = (id) => root + 'variants/' + id + '.js';

  const drawer = document.getElementById('CodCartDrawer');
  if (!drawer) return;

  // IMPORTANT: query INSIDE the drawer to avoid duplicate IDs on the page
  const listEl = drawer.querySelector('#CodDrawerCartList');
  const emptyEl = drawer.querySelector('#CodDrawerEmpty');
  const msgEl = drawer.querySelector('#CodDrawerMsg');

  const subtotalEl = drawer.querySelector('#CodDrawerSubtotal');
  const shipEl = drawer.querySelector('#CodDrawerShipping');
  const totalEl = drawer.querySelector('#CodDrawerTotal');
  const checkoutBtn = drawer.querySelector('#CodDrawerCheckoutBtn');

  // Shipping UI (must exist from Liquid)
  const shipMsgEl = drawer.querySelector('#CodDrawerShipMsg');
  const shipBarFillEl = drawer.querySelector('#CodDrawerShipBarFill');

  const closeEls = drawer.querySelectorAll('[data-cod-drawer-close]');

  const FREE_THRESHOLD = 1000;

  function setMsg(type, text) {
    if (!msgEl) return;
    msgEl.classList.remove('ok', 'err');
    if (!text) { msgEl.textContent = ''; return; }
    msgEl.classList.add(type === 'ok' ? 'ok' : 'err');
    msgEl.textContent = text;
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setMsg('', '');
    refreshCart();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setMsg('', '');
  }

  closeEls.forEach(el => el.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* =========================
     MOBILE FIX (reliable):
     - capture click/touch/pointer on document
     - prevent Shopify navigation to /cart
  ========================= */

  function shouldInterceptCartTarget(target) {
    if (!target) return null;

    // best: set data-open-cod-cart="1" on your cart icon element
    let a = target.closest('[data-open-cod-cart="1"]');
    if (a) return a;

    // Dawn cart icon bubble
    a = target.closest('#cart-icon-bubble');
    if (a) return a;

    // any link going to /cart
    a = target.closest('a[href*="/cart"]');
    if (a) return a;

    return null;
  }

  function handleCartOpen(e) {
    // NOTE: this used to also require #CodPopupOpen/#CodPopup to exist on
    // the page before intercepting the click. That modal is only rendered
    // on the product template, so on collection/home/other pages the guard
    // failed silently and the browser fell through to the native /cart
    // link. The drawer itself only needs cart.js, not the COD modal, so we
    // open it unconditionally here. The COD modal is only required later,
    // when "Commander" is clicked (handled separately below with a
    // fallback for pages where it isn't present).
    const link = shouldInterceptCartTarget(e.target);
    if (!link) return;

    // If it's a link, confirm it is truly cart
    const href = (link.getAttribute('href') || '').toLowerCase();
    if (href && !href.includes('/cart')) return;

    // Avoid double-open if already open
    if (drawer.classList.contains('is-open')) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    openDrawer();
  }

  document.addEventListener('click', handleCartOpen, true);
  document.addEventListener('pointerup', handleCartOpen, true);
  document.addEventListener('touchend', handleCartOpen, { capture: true });

  async function fetchJSON(url, options) {
    const res = await fetch(url, options);
    const text = await res.text();
    let json = null;
    try { json = text ? JSON.parse(text) : null; } catch (e) {}
    return { res, json, text };
  }

  async function postChangeWithRetry(payload) {
    const req = () => fetchJSON(CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });

    let out = await req();

    if (out.res && out.res.status === 429) {
      const ra = out.res.headers.get('Retry-After');
      const delayMs = ra ? Math.min(2000, Math.max(300, parseFloat(ra) * 1000)) : 700;
      await new Promise(r => setTimeout(r, delayMs));
      out = await req();
    }
    return out;
  }

  const stockCache = new Map();
  async function getMaxStock(variantId) {
    if (!variantId) return null;
    if (stockCache.has(variantId)) return stockCache.get(variantId);

    const { res, json } = await fetchJSON(VARIANT_URL(variantId), { method: 'GET', headers: { 'Accept': 'application/json' } });
    if (!res.ok || !json) {
      stockCache.set(variantId, null);
      return null;
    }

    const qty = (typeof json.inventory_quantity === 'number') ? json.inventory_quantity : null;
    stockCache.set(variantId, qty);
    return qty;
  }

  function money(cartCurrency, cents) {
    const amount = cents / 100;
    try {
      return new Intl.NumberFormat('fr-MA', { style: 'currency', currency: cartCurrency || 'MAD' }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' MAD';
    }
  }

  function normalizeCity(city) {
    return String(city || '')
      .trim()
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // remove accents
  }

  // ✅ Shipping rules aligned with PHP:
  // - Tanger: FREE always
  // - Casablanca: 20 DH
  // - Others: 30 DH
  // - Also: FREE if subtotal >= 1000 (but Tanger already free)
  function isTanger(city) {
    const c = normalizeCity(city);
    return c === 'tanger' || c === 'tangier' || c === 'tanja' || c.includes('tanger') || c.includes('tangier') || c.includes('طنجة');
  }

  function isCasa(city) {
    const c = normalizeCity(city);
    return c === 'casablanca' || c === 'casa' || c.includes('casablanca') || c.includes('الدار');
  }

  function computeShippingMAD(subtotalDh, city) {
    if (isTanger(city)) return 0;
    if ((Number(subtotalDh) || 0) >= FREE_THRESHOLD) return 0;
    if (isCasa(city)) return 20;
    return 30;
  }

  function updateFreeShippingUI(subtotalDh, city) {
    const sub = Number(subtotalDh) || 0;

    // If Tanger => already free
    if (isTanger(city)) {
      if (shipMsgEl) shipMsgEl.textContent = 'Livraison gratuite à Tanger.';
      if (shipBarFillEl) shipBarFillEl.style.setProperty('width', '100%', 'important');
      const bar = shipBarFillEl ? shipBarFillEl.closest('.cod-shipbar') : null;
      if (bar) {
        bar.classList.add('is-full');
        bar.setAttribute('aria-valuenow', '100');
      }
      return;
    }

    const remaining = Math.max(0, FREE_THRESHOLD - sub);
    const pct = (sub >= FREE_THRESHOLD)
      ? 100
      : Math.max(0, Math.min(100, (sub / FREE_THRESHOLD) * 100));

    if (shipMsgEl) {
      if (remaining <= 0) {
        shipMsgEl.textContent = 'Félicitations ! Vous bénéficiez de la livraison gratuite';
      } else {
        shipMsgEl.textContent = `Il ne vous manque plus que ${Math.ceil(remaining)} dh pour atteindre la livraison gratuite !`;
      }
    }

    if (shipBarFillEl) {
      shipBarFillEl.style.setProperty('width', pct.toFixed(2) + '%', 'important');

      const bar = shipBarFillEl.closest('.cod-shipbar');
      if (bar) {
        bar.classList.toggle('is-full', sub >= FREE_THRESHOLD);
        bar.setAttribute('aria-valuenow', String(Math.round(pct)));
      }

      // force repaint on some mobile browsers
      // eslint-disable-next-line no-unused-expressions
      shipBarFillEl.offsetWidth;
    }
  }

  const timers = new Map();
  const inflight = new Set();

  function disableLine(lineKey, disabled) {
    const row = drawer.querySelector(`[data-line-key="${CSS.escape(lineKey)}"]`);
    if (!row) return;
    row.querySelectorAll('input,button').forEach(el => { el.disabled = disabled; });
  }

  function scheduleQtyChange(lineKey, lineIndex, variantId, desiredQty) {
    if (timers.has(lineKey)) clearTimeout(timers.get(lineKey));
    timers.set(lineKey, setTimeout(() => applyQtyChange(lineKey, lineIndex, variantId, desiredQty), 280));
  }

  async function applyQtyChange(lineKey, lineIndex, variantId, desiredQty) {
    if (inflight.has(lineKey)) return;

    inflight.add(lineKey);
    disableLine(lineKey, true);

    try {
      let qty = Math.max(0, parseInt(desiredQty || 0, 10));

      // only check stock for qty > 0
      if (qty > 0) {
        const maxStock = await getMaxStock(variantId);
        if (maxStock !== null && qty > maxStock) {
          qty = maxStock;
          setMsg('err', `Stock insuffisant. Quantité max: ${maxStock}`);
        }
      }

      // Shopify change.js uses 1-based line number
      const { res, json } = await postChangeWithRetry({ line: Number(lineIndex), quantity: qty });

      if (res.status === 422) {
        setMsg('err', (json && json.description) ? json.description : 'Quantité non disponible.');
        await refreshCart();
        return;
      }

      if (!res.ok || !json) {
        setMsg('err', 'Erreur de mise à jour du panier.');
        await refreshCart();
        return;
      }

      setMsg('', '');
      await renderCart(json);
    } catch (e) {
      setMsg('err', 'Erreur réseau. Réessayez.');
      await refreshCart();
    } finally {
      inflight.delete(lineKey);
      disableLine(lineKey, false);
    }
  }

  async function refreshCart() {
    if (checkoutBtn) checkoutBtn.disabled = true;

    const { res, json } = await fetchJSON(CART_URL, { method: 'GET', headers: { 'Accept': 'application/json' } });
    if (!res.ok || !json) {
      setMsg('err', 'Impossible de charger le panier.');
      return;
    }
    await renderCart(json);
  }

  function bestImageFromItem(it) {
    // cart.js typically returns item.image (string URL) or null
    if (it && typeof it.image === 'string' && it.image) return it.image;

    // sometimes themes expose featured_image { url: ... }
    const fi = it && it.featured_image;
    if (fi && typeof fi.url === 'string' && fi.url) return fi.url;

    // fallback: try via product/variant
    if (it && typeof it.url === 'string' && it.url) return it.url;

    return ''; // handled by placeholder in HTML
  }

  async function renderCart(cart) {
    const items = cart.items || [];
    if (listEl) listEl.innerHTML = '';

    if (emptyEl) {
      if (!items.length) {
        emptyEl.style.display = 'block';
        if (checkoutBtn) checkoutBtn.disabled = true;
      } else {
        emptyEl.style.display = 'none';
        if (checkoutBtn) checkoutBtn.disabled = false;
      }
    }

    const subtotalCents = cart.items_subtotal_price || 0;
    const subtotalDh = subtotalCents / 100;

    // city from your COD form (if exists)
    const cityInput = document.getElementById('CodCity');
    const city = cityInput ? cityInput.value : '';

    const shipDh = computeShippingMAD(subtotalDh, city);
    const shipCents = Math.round(shipDh * 100);
    const totalCents = subtotalCents + shipCents;

    if (subtotalEl) subtotalEl.textContent = money(cart.currency, subtotalCents);
    if (shipEl) shipEl.textContent = shipDh === 0 ? 'Gratuite' : money(cart.currency, shipCents);
    if (totalEl) totalEl.textContent = money(cart.currency, totalCents);

    updateFreeShippingUI(subtotalDh, city);

    if (!listEl) return;

    items.forEach((it, idx) => {
      const img = bestImageFromItem(it);
      const productTitle = it.product_title || it.title || '';
      const variantTitle = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';

      const lineKey = String(it.key);
      const lineIndex = idx + 1; // 1-based

      const row = document.createElement('div');
      row.className = 'cod-item';
      row.setAttribute('data-line-key', lineKey);

      const imgHtml = img
        ? `<img class="cod-item__img" src="${escapeHtml(img)}" alt="">`
        : `<div class="cod-item__img cod-item__img--ph" aria-hidden="true"></div>`;

      row.innerHTML = `
        ${imgHtml}
        <div class="cod-item__content">
          <p class="cod-item__title">${escapeHtml(productTitle)}</p>
          ${variantTitle ? `<div class="cod-item__variant">${escapeHtml(variantTitle)}</div>` : ''}
          <div class="cod-item__price">${money(cart.currency, it.final_line_price != null ? it.final_line_price : (it.line_price || 0))}</div>

          <div class="cod-item__controls">
            <div class="cod-qtybox">
              <button type="button" class="cod-qty-btn" data-qty="-1" aria-label="Moins">−</button>
              <input class="cod-qty-input" type="number" min="0" inputmode="numeric" pattern="[0-9]*" value="${it.quantity}">
              <button type="button" class="cod-qty-btn" data-qty="+1" aria-label="Plus">+</button>
            </div>
            <button type="button" class="cod-remove">Supprimer</button>
          </div>
        </div>
      `;

      const qtyInput = row.querySelector('.cod-qty-input');

      row.querySelectorAll('.cod-qty-btn').forEach(btn => {
        btn.addEventListener('click', async () => {
          const delta = (btn.getAttribute('data-qty') === '+1') ? 1 : -1;
          const current = parseInt(qtyInput.value || '0', 10);
          let next = Math.max(0, current + delta);

          const maxStock = await getMaxStock(it.variant_id);
          if (maxStock !== null && next > maxStock) next = maxStock;

          qtyInput.value = String(next);
          scheduleQtyChange(lineKey, lineIndex, it.variant_id, next);
        });
      });

      qtyInput.addEventListener('input', async (e) => {
        const v = parseInt(e.target.value || '0', 10);
        const maxStock = await getMaxStock(it.variant_id);
        if (maxStock !== null && v > maxStock) e.target.value = String(maxStock);
        scheduleQtyChange(lineKey, lineIndex, it.variant_id, e.target.value);
      });

      row.querySelector('.cod-remove').addEventListener('click', () => {
        scheduleQtyChange(lineKey, lineIndex, it.variant_id, 0);
      });

      listEl.appendChild(row);
    });
  }

  function escapeHtml(str) {
    return String(str || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  // Bridge button: close drawer -> open COD modal (if present on this page)
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      if (checkoutBtn.disabled) return;
      closeDrawer();

      const openBtn = document.getElementById('CodPopupOpen');
      const modal = document.getElementById('CodPopup');

      if (openBtn && modal) {
        openBtn.click();
        return;
      }

      // The COD modal only exists on the product template. If the customer
      // opened the drawer from a collection/home/other page and clicks
      // "Commander" there, fall back to the real Shopify cart page instead
      // of doing nothing — their cart items are already saved server-side,
      // so they can still check out from there.
      window.location.href = root + 'cart';
    });
  }

})();